const state = {
  // 再来一单选中的购物车ID
  addSuccessCartIds: [],
  // 加购失败的购物车Id列表
  addCartFailList: []
};

const getters = {};

const mutations = {
  SET_CART_IDS(state, data) {
    state.addSuccessCartIds = data;
  },
  SET_FAIL_LIST(state, data) {
    state.addCartFailList = data;
  }
};

const actions = {
  setSuccessCartIds({ commit }, data) {
    commit('SET_CART_IDS', data);
  },
  setCartFailList({ commit }, data) {
    commit('SET_FAIL_LIST', data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
